"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactJss = _interopRequireDefault(require("react-jss"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ = require("../.");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class MultiSelect extends _react.default.Component {
  constructor(...args) {
    super(...args);
    this.state = {
      isOpen: false
    };
  }

  render() {
    const _this$props = this.props,
          name = _this$props.name,
          value = _this$props.value,
          placeholder = _this$props.placeholder,
          required = _this$props.required,
          setValue = _this$props.setValue,
          options = _this$props.options,
          classes = _this$props.classes;
    const isOpen = this.state.isOpen;
    return _react.default.createElement("div", {
      className: (0, _classnames.default)(classes.select, classes.multiSelect, 'form-input form-select'),
      onClick: () => !isOpen && this.setState({
        isOpen: true
      })
    }, value && value.length && options && options.length ? _react.default.createElement("div", {
      className: classes.values
    }, value.map((item, index) => {
      const selectedOption = options.find(option => option.value === item);
      return _react.default.createElement("span", {
        key: index,
        className: classes.value
      }, typeof selectedOption === 'string' ? item : selectedOption.label);
    })) : placeholder || (required ? 'Select' : 'All'), isOpen && _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("div", {
      className: classes.overlay,
      onClick: () => this.setState({
        isOpen: false
      })
    }), _react.default.createElement("div", {
      className: classes.options
    }, options.map((option, index) => {
      const optionLabel = typeof option === 'string' ? option : option.label;
      const optionValue = typeof option === 'string' ? option : option.value;
      const checked = value && value.includes(optionValue);
      return _react.default.createElement("div", {
        key: index,
        className: (0, _classnames.default)(classes.option, {
          [classes.isChecked]: checked
        }),
        onClick: () => setValue(name, (0, _.checkboxHandler)(!checked, optionValue, value), required)
      }, optionLabel, checked && _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("span", {
        className: classes.check
      }, "\u2713"), _react.default.createElement("span", {
        className: classes.close
      }, "\u2717")));
    }))));
  }

}

MultiSelect.propTypes = {
  name: _propTypes.default.string.isRequired,
  value: _propTypes.default.oneOfType([_propTypes.default.array, _propTypes.default.string]),
  placeholder: _propTypes.default.node,
  required: _propTypes.default.bool,
  setValue: _propTypes.default.func.isRequired,
  options: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
    label: _propTypes.default.string,
    value: _propTypes.default.string
  })]))
};

var _default = (0, _.withFormControl)((0, _reactJss.default)(theme => _objectSpread(_objectSpread({}, (0, _.selectTheme)(theme)), {}, {
  multiSelect: {
    position: 'relative',
    height: 'auto !important'
  },
  values: {
    margin: -3
  },
  value: {
    padding: '0 5px',
    backgroundColor: theme.colors.fill,
    borderRadius: 3,
    whiteSpace: 'nowrap',
    display: 'inline-block',
    margin: 3
  },
  options: {
    position: 'absolute',
    top: '100%',
    left: -1,
    right: -2,
    height: theme.sizes.inputHeight * 5,
    border: "1px solid ".concat(theme.colors.inputBorder),
    backgroundColor: 'white',
    zIndex: 101,
    overflowY: 'scroll'
  },
  option: {
    padding: '3px 5px',
    marginBottom: 1,
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'space-between',
    '&:hover': {
      backgroundColor: 'rgba(0,0,0,0.04)'
    }
  },
  isChecked: {
    backgroundColor: 'rgba(0,0,0,0.12)',
    '&:hover ': {
      backgroundColor: 'rgba(0,0,0,0.08)',
      '& $check': {
        display: 'none'
      },
      '& $close': {
        display: 'inline'
      }
    }
  },
  check: {
    color: 'rgba(0,0,0,0.12)'
  },
  close: {
    display: 'none',
    color: 'rgba(0,0,0,0.2)'
  },
  overlay: _objectSpread({}, (0, _.overlay)())
}))(MultiSelect));

exports.default = _default;